import React from 'react'
import { Controller } from 'react-hook-form'
import cx from 'classnames'

import type { ControlledFieldProps, FormFieldBaseProps } from '../../types'
import styles from './Textarea.module.scss'

type TextareaProps = FormFieldBaseProps & {
  placeholder?: string
  value?: string
  onBlur?: React.FocusEventHandler<HTMLTextAreaElement>
  onChange?: React.ChangeEventHandler<HTMLTextAreaElement>
  isReadOnly?: boolean
}

export const Textarea = React.forwardRef<HTMLTextAreaElement, TextareaProps>(
  (
    {
      error,
      fieldClassName,
      id,
      name,
      placeholder,
      value,
      onBlur,
      onChange,
      isDisabled = false,
      isReadOnly = false,
      isRequired = false,
    },
    ref,
  ) => (
    <textarea
      className={cx(styles.textarea, fieldClassName, {
        [styles.invalid]: Boolean(error),
      })}
      disabled={isDisabled}
      readOnly={isReadOnly}
      required={isRequired}
      {...{ id, name, placeholder, ref, value, onBlur, onChange }}
    />
  ),
)

type ControlledTextareaProps = ControlledFieldProps &
  Pick<TextareaProps, 'placeholder' | 'isReadOnly'>

export const ControlledTextarea = ({
  control,
  error,
  fieldClassName,
  id,
  name,
  placeholder,
  isDisabled,
  isReadOnly,
  isRequired,
}: ControlledTextareaProps) => (
  <Controller
    render={({ field: { name, ref, value, onBlur, onChange } }) => (
      <Textarea
        {...{
          error,
          fieldClassName,
          id,
          name,
          placeholder,
          ref,
          value,
          onBlur,
          onChange,
          isDisabled,
          isReadOnly,
          isRequired,
        }}
      />
    )}
    {...{ control, name }}
  />
)
